"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importStar(require("styled-components"));
var Tooltip_1 = __importDefault(require("./Tooltip"));
var MoreInfoIcon_1 = __importDefault(require("./MoreInfoIcon"));
var AUTO = "auto";
var COMPACT = "compact";
var FULL = "full";
var SummaryDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n\tflex-wrap: nowrap;\n\talign-items: flex-end;\n\t", ";\n"], ["\n    display: flex;\n\tflex-wrap: nowrap;\n\talign-items: flex-end;\n\t", ";\n"])), function (props) { return props.theme.priceSummary.root; });
var FullSummaryDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: inline-block;\n\t@media ", ", ", " {\n\t\t", "\n\t}\n"], ["\n\tdisplay: inline-block;\n\t@media ", ", ", " {\n\t\t", "\n\t}\n"])), function (props) { return props.theme.breakpoints.S; }, function (props) { return props.theme.breakpoints.M; }, function (props) { return !props.force && "display: none;"; });
var TotalPrice = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t", ";\n"], ["\n\t", ";\n"])), function (props) { return props.theme.priceSummary.total; });
var TotalPriceValue = styled_components_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tvertical-align: text-bottom;\n"], ["\n\tvertical-align: text-bottom;\n"])));
var FeeLegal = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\ttext-align: left;\n\tfont-size: 13px;\n\t@media ", ", ", " {\n\t\tfont-size: 8px;\n\t}\n"], ["\n\ttext-align: left;\n\tfont-size: 13px;\n\t@media ", ", ", " {\n\t\tfont-size: 8px;\n\t}\n"])), function (props) { return props.theme.breakpoints.S; }, function (props) { return props.theme.breakpoints.M; });
var Surcharge = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", ";\n"], ["\n    ", ";\n"])), function (props) { return props.theme.priceSummary.surcharge; });
var SurchargeValue = styled_components_1.default.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", ";\n"], ["\n    ", ";\n"])), function (props) { return props.theme.priceSummary.surchargeText; });
var MonthlyPrice = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\t", ";\n"], ["\n\t", ";\n"])), function (props) { return props.theme.priceSummary.monthly; });
var Adjust = styled_components_1.default.button(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-wrap: nowrap;\n\talign-items: center;\n\t", ";\n"], ["\n\tdisplay: flex;\n\tflex-wrap: nowrap;\n\talign-items: center;\n\t", ";\n"])), function (props) { return props.theme.priceSummary.adjust; });
var Calculator = styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\t", ";\n\t/*margin-bottom: 20px;*/\n"], ["\n\t", ";\n\t/*margin-bottom: 20px;*/\n"])), function (props) { return props.theme.priceSummary.calculator; });
var PriceSummary = /** @class */ (function (_super) {
    __extends(PriceSummary, _super);
    function PriceSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PriceSummary.prototype.render = function () {
        return (react_1.default.createElement(SummaryDiv, null,
            react_1.default.createElement("div", { style: { display: 'inline-block' } },
                react_1.default.createElement(TotalPrice, null,
                    react_1.default.createElement(TotalPriceValue, { "data-automationid": "totalprice" }, this.props.total),
                    this.props.disclaimer &&
                        react_1.default.createElement(Tooltip_1.default, { position: "top-start", label: this.props.disclaimer, contents: this.props.disclaimer, automationId: "showfooterpricedisclaimer" },
                            react_1.default.createElement(MoreInfoIcon_1.default, null))),
                this.props.feelegal && react_1.default.createElement(FeeLegal, null, this.props.feelegal),
                react_1.default.createElement(MonthlyPrice, { onClick: this.props.onAdjust ? this.props.onAdjust : undefined, "data-automationid": "monthlyprice" }, this.props.monthly),
                this.props.surcharge &&
                    react_1.default.createElement(Surcharge, null,
                        react_1.default.createElement(SurchargeValue, { "data-automationid": "surcharge" }, this.props.surcharge))),
            this.props.adjust && this.props.onAdjust && this.props.size !== COMPACT &&
                react_1.default.createElement(FullSummaryDiv, { force: this.props.size === FULL },
                    react_1.default.createElement(Adjust, { onClick: this.props.onAdjust, style: {}, "data-automationid": "showfinancecalculator" },
                        react_1.default.createElement(Calculator, null, this.props.theme.svgs.calculator),
                        react_1.default.createElement("div", null, this.props.adjust)))));
    };
    PriceSummary.propTypes = {
        /** total price including currency marker and desired formatting */
        total: prop_types_1.default.node.isRequired,
        /** Messaging relating to any additional fees that must always be displayed (can't just be in the disclaimer tooltip) */
        feelegal: prop_types_1.default.string,
        /** monthly price including currency marker and desired formatting */
        monthly: prop_types_1.default.node.isRequired,
        /** disclaimer */
        disclaimer: prop_types_1.default.node,
        /** title of adjust button */
        adjust: prop_types_1.default.string,
        /** Event to get called when clicking the adjust button */
        onAdjust: prop_types_1.default.func,
        /** override the sizing */
        size: prop_types_1.default.oneOf([AUTO, COMPACT, FULL]),
        /** surcharge info */
        surcharge: prop_types_1.default.node,
    };
    PriceSummary.defaultProps = {
        total: '$00.00',
        monthly: '$00.00',
    };
    return PriceSummary;
}(react_1.Component));
exports.default = styled_components_1.withTheme(PriceSummary);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
//# sourceMappingURL=PriceSummary.js.map